<template>
  <div class="mars-list">
    <div class="filters-container" ref="filtersContainer">
      <div
        class="d-flex flex-row justify-content-between align-items-center bg-light-gray min-width-fit-content"
      >
        <div class="d-flex flex-wrap align-items-center">
          <span class="ml-4 mr-3" style="font-size: 14px;"
            >Active filters:</span
          >
          <div
            v-if="(filter.dateFrom || filter.dateTo) && selectedLocationObj"
            class="filter-value bg-white border pr-2 pt-1 pb-1 m-1"
          >
            <div class="d-flex justify-content-between align-items-center">
              <span class="mr-3"
                >Date &amp; Time:
                <span class="color-filter"
                  >{{
                    filter.dateFrom || filter.dateTo
                      ? `(${
                          filter.dateFrom
                            ? "From: " +
                              (this.selectedLocationObj.marsMilitaryTimes
                                ? formatDateOnly(filter.dateFrom) +
                                  " " +
                                  (filter.timeFrom
                                    ? filter.timeFrom.value
                                    : "00:00")
                                : formatDate(
                                    filter.dateFrom +
                                      " " +
                                      (filter.timeFrom
                                        ? filter.timeFrom.value
                                        : "00:00")
                                  ))
                            : ""
                        }${filter.dateFrom && filter.dateTo ? " - " : ""}${
                          filter.dateTo
                            ? "To: " +
                              (this.selectedLocationObj.marsMilitaryTimes
                                ? formatDateOnly(filter.dateTo) +
                                  " " +
                                  (filter.timeTo
                                    ? filter.timeTo.value
                                    : "23:59")
                                : formatDate(
                                    filter.dateTo +
                                      " " +
                                      (filter.timeTo
                                        ? filter.timeTo.value
                                        : "23:59")
                                  ))
                            : ""
                        })`
                      : ""
                  }}
                </span></span
              >
              <i
                class="fa fa-times hover-pointer hover-text-almost-black"
                @click="removeDateFilter()"
              ></i>
            </div>
          </div>
          <div
            class="filter-value bg-white border pr-2 pt-1 pb-1 m-1"
            v-for="(m, mIndex) in filter.marsStatus"
            :key="m.value"
          >
            <div class="d-flex justify-content-between align-items-center">
              <span class="mr-3">
                Status:
                <span class="color-filter">{{ m.label }}</span>
              </span>
              <i
                class="fa fa-times hover-pointer hover-text-almost-black"
                @click="removeStatusFilter(mIndex)"
              ></i>
            </div>
          </div>
          <div
            class="filter-value bg-white border pr-2 pt-1 pb-1 m-1"
            v-for="(c, cIndex) in filter.eoc"
            :key="c.value"
          >
            <div class="d-flex justify-content-between align-items-center">
              <span class="mr-3"
                >Patient: <span class="color-filter">{{ c.label }}</span></span
              >
              <i
                class="fa fa-times hover-pointer hover-text-almost-black"
                @click="removeEocFilter(cIndex)"
              ></i>
            </div>
          </div>
          <div
            class="filter-value bg-white border pr-2 pt-1 pb-1 m-1"
            v-for="(m, mIndex) in filter.medication"
            :key="m.value"
          >
            <div class="d-flex justify-content-between align-items-center">
              <span class="mr-3"
                >Medication:
                <span class="color-filter">{{ m.label }}</span></span
              >
              <i
                class="fa fa-times hover-pointer hover-text-almost-black"
                @click="removeMedicationFilter(mIndex)"
              ></i>
            </div>
          </div>
          <span
            v-if="hasFilters"
            class="clear-all-filters text-danger ml-2"
            style="font-size: 14px;"
            @click="clearAllFilters"
            >Clear all filters</span
          >
        </div>
        <div class="d-flex align-self-stretch align-items-center">
          <div class="align-self-stretch" style="padding: 9px 0px;">
            <div class="vertical-separator border-med-light-gray"></div>
          </div>
          <b-dropdown
            id="dropdown-form"
            text="Filters"
            ref="filterDropdown"
            class="container-main bg-light-gray"
            toggle-class="d-flex flex-row justify-content-between align-items-lg-center bg-transparent border-0 color-custom-dark-grey dropdown-menu-label"
            menu-class="container-filter-main-menu"
            toggle-tag="div"
            boundary="window"
            right
          >
            <template #button-content>
              <div class="d-flex align-items-center mr-2">
                <i
                  class="fas fa-filter text-primary mr-2"
                  style="font-size: 15px;"
                  aria-hidden="true"
                ></i>
                <span style="font-size: 14px;">Filters</span>
              </div>
            </template>
            <b-dropdown-form class="px-2">
              <b-form-group label="Filter by:">
                <b-form-select
                  v-model="selectedFilter"
                  :options="filterOptions"
                />
              </b-form-group>
              <div
                v-if="selectedFilter == 'dateTime'"
                class="d-flex flex-row justify-content-between"
              >
                <div>
                  <b-form-group label="From Date" class="mr-4 ml-4">
                    <b-calendar
                      v-model="filter.dateFrom"
                      :date-format-options="{
                        year: 'numeric',
                        day: '2-digit',
                        month: '2-digit'
                      }"
                      width="200px"
                    >
                    </b-calendar>
                  </b-form-group>
                  <b-form-group label="From Time" class="mr-4 ml-4">
                    <v-select
                      v-if="selectedLocationObj"
                      class=""
                      placeholder=""
                      v-model="filter.timeFrom"
                      :options="timeOptions"
                      :append-to-body="true"
                    ></v-select>
                  </b-form-group>
                  <div class="d-flex justify-content-center" dir="ltr">
                    <b-button
                      size="sm"
                      variant="outline-danger"
                      v-if="filter.dateFrom"
                      @click.prevent.stop="
                        filter.dateFrom = null;
                        filter.timeFrom = null;
                      "
                    >
                      Clear date &amp; time
                    </b-button>
                  </div>
                </div>
                <div>
                  <b-form-group label="To Date" class="mr-4 ml-4">
                    <b-calendar
                      v-model="filter.dateTo"
                      :date-format-options="{
                        year: 'numeric',
                        day: '2-digit',
                        month: '2-digit'
                      }"
                      width="200px"
                    >
                    </b-calendar>
                  </b-form-group>
                  <b-form-group label="To Time" class="mr-4 ml-4">
                    <v-select
                      v-if="selectedLocationObj"
                      class=""
                      placeholder=""
                      v-model="filter.timeTo"
                      :options="timeOptions"
                      :append-to-body="true"
                    ></v-select>
                  </b-form-group>
                  <div class="d-flex justify-content-center" dir="ltr">
                    <b-button
                      size="sm"
                      variant="outline-danger"
                      v-if="filter.dateTo"
                      @click.prevent.stop="
                        filter.dateTo = null;
                        filter.timeTo = null;
                      "
                    >
                      Clear date &amp; time
                    </b-button>
                  </div>
                </div>
              </div>

              <multiple-select-filter
                v-if="selectedFilter == 'status'"
                v-model="filter.marsStatus"
                :options="marsStatuses"
                :label="'Status'"
                :width="'250px'"
                :showSearch="false"
                :key="'status'"
              />

              <multiple-select-filter
                v-if="selectedFilter == 'patient'"
                :label="'Patients'"
                :options="clientOptions"
                v-model="filter.eoc"
                :width="filterPatientWidth"
                :showSearch="true"
                :async="true"
                :searching="searchingClients"
                @on-search="fetchClientOptions"
                :key="'patient'"
              >
                <template v-slot:item-option="{ itemOption, selected }">
                  <eoc-filter-option-template
                    :eoc="itemOption.data"
                    :selected="selected"
                  />
                </template>
              </multiple-select-filter>
              <multiple-select-filter
                v-if="selectedFilter == 'medication'"
                :label="'Medications'"
                :options="medications"
                v-model="filter.medication"
                :width="filterWidth"
                :showSearch="true"
                :async="true"
                :searching="searchingMedications"
                @on-search="searchMedications"
                :key="'medication'"
              >
                <template v-slot:item-option="{ itemOption, selected }">
                  <div
                    class="d-flex flex-row justify-content-between align-items-center mb-1 pl-3 pr-3 pt-1 pb-1"
                  >
                    <span>{{ itemOption.label }}</span>
                    <img
                      v-show="selected"
                      :src="require('../../assets/icons/check.png')"
                    />
                  </div>
                </template>
              </multiple-select-filter>
            </b-dropdown-form>
          </b-dropdown>
        </div>
      </div>
    </div>
    <div class="mt-3 mb-0 w-100 d-flex flex-row justify-content-between">
      <div class="d-flex align-items-center" style="font-size: 19px;">
        <a
          class="hover-pointer"
          style="font-size: 14px"
          @click="showReportRequestsModal = true"
        >
          <i class="fa fa-download"></i>
          <span class="ml-2 text-primary" style="font-size: 14px">Export</span>
        </a>
        <div
          v-if="currentUser && !currentUser.onlyAccessAssignedPatients"
          class="border-left border-med-light-gray pl-1 ml-1 mr-1"
          style="width: 1px; height: 19px"
        ></div>
        <vue-toggles
          v-if="currentUser && !currentUser.onlyAccessAssignedPatients"
          @click="changeAssignedToMEToggle()"
          :value="assignedToMe"
          height="20"
          width="30"
          checkedBg="#34C759"
          uncheckedBg="#FF6161"
        />
        <small
          v-if="currentUser && !currentUser.onlyAccessAssignedPatients"
          class="ml-2"
          >Show My Patients only</small
        >
      </div>
      <div class="d-flex flex-row justify-content-end align-items-center">
        <top-paginator
          :total="listTotal"
          :page="filter.page"
          :perPage="filter.pageSize"
          @change-page="changePage"
        />
      </div>
    </div>
    <div
      :style="
        `--document-list-filters-container-height:calc(${filtersContainerHeight}px);`
      "
    >
      <grid
        ref="grid"
        :groupFeature="false"
        :autoHeight="false"
        :columns="columns"
        :data="items"
        :store="gridConfig.store"
        :selectionMode="gridConfig.selectionMode"
        :columnLines="gridConfig.columnLines"
        :searchFeature="true"
        :stripeFeature="false"
        @storesort="listeners.storeSort"
        @paint="listeners.paint"
        @renderrows="hookDropdownButtons"
        @renderrow="hookDropdownButtons"
      ></grid>
    </div>

    <mars-add-edit-medication-modal
      v-if="showAddEditMedication"
      v-model="showAddEditMedication"
      @onModify="onModifyAddEditMedication"
      :medicationId="editMedicationId"
    />
    <report-request-index
      v-if="showReportRequestsModal"
      v-model="showReportRequestsModal"
      :reportFilters="exportFilter"
      reportName="MedicalAdminRecords"
    />
  </div>
</template>

<script>
import Grid from "../../third_party/grid/Grid.vue";
import TopPaginator from "../controls/TopPaginator.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import marsServer from "../../server/marsRecord";
import eocServer from "../../server/eoc";
import {
  formatTimeOnly,
  formatDateTimeSql,
  formatDateOnlyMysql,
  formatDate,
  parseNearestTime,
  formatTimeOnlyMysql,
  formatToMilitaryTime,
  formatDateOnly
} from "../../helpers/date";
import { timeOptions } from "../../config/medications";
import { validateRequired } from "../../helpers/validation";
import { on } from "../../helpers/layout";
import medicationServer from "../../server/medication";
import prnMedicationServer from "../../server/prnMedication";
import moment from "moment";
import MarsAddEditMedicationModal from "./MarsAddEditMedicationModal";
import EocFilterOptionTemplate from "../../views/EocFilterOptionTemplate";
import { formatUser } from "../../helpers/user";
import ReportRequestIndex from "../report_request/ReportRequestIndex.vue";

export default {
  name: "MarsList",
  components: {
    Grid,
    TopPaginator,
    MarsAddEditMedicationModal,
    EocFilterOptionTemplate,
    ReportRequestIndex
  },
  props: ["showing", "assignedToMeValue"],
  data() {
    const self = this;
    return {
      list: [],
      listTotal: 0,
      clientOptions: [],
      medications: [],
      filterWidth: "250px",
      filterPatientWidth: "350px",
      selectedFilter: "dateTime",
      filterOptions: [
        {
          value: "dateTime",
          text: "Date & Time"
        },
        {
          value: "status",
          text: "Status"
        },
        {
          value: "patient",
          text: "Patient"
        },
        {
          value: "medication",
          text: "Medication"
        }
      ],
      filter: {
        eoc: [],
        medication: [],
        marsStatus: [],
        dateFrom: formatDateOnlyMysql(),
        timeFrom: null,
        dateTo: null,
        timeTo: null,
        page: 0,
        pageSize: 50,
        orderBy: "datetime",
        orderByDescending: false
      },
      marsStatuses: [
        {
          value: "Pending",
          label: "Pending"
        },
        {
          value: "Given",
          label: "Given"
        },
        {
          value: "NotGiven",
          label: "Not Given"
        }
      ],
      gridConfig: {
        minHeight: "20em",
        columnLines: false,
        store: {
          // Default sorters
          sorters: [{ field: "datetime", ascending: true }]
        }
      },
      formPrnId: null,
      formPrn: {
        patient: null,
        medication: null,
        dateTime: "",
        type: "",
        eoc: null,
        prnMedication: null,
        date: null,
        time: null,
        status: "",
        notes: "",
        givenBy: null
      },
      formPrnErrors: {
        eoc: [],
        prnMedication: [],
        date: [],
        time: [],
        status: []
      },
      listeners: {
        paint: paintEvent => {
          if (paintEvent.firstPaint) {
            if (!self.subscribed) {
              self.subscribed = true;
              on(self.$el, "change", ".edit-notes-item", async target => {
                await marsServer.update(target.dataset.marsId, {
                  notes: target.value
                });
                await self.fetchMars();
                self.showAlertSuccess();
              });
              on(self.$el, "change", ".edit-status-item", async target => {
                await marsServer.update(target.dataset.marsId, {
                  status: target.value
                });
                await self.fetchMars();
                self.showAlertSuccess();
              });
              on(
                self.$el,
                "click",
                ".delete-prn-medication-item",
                async target => {
                  self.$dialog
                    .confirm(
                      {
                        title: "Are you sure you want to delete this record?"
                      },
                      {
                        view: "confirm-delete"
                      }
                    )
                    .then(async () => {
                      await marsServer.delete(target.dataset.marsId);
                      await self.fetchMars();
                      self.showAlertSuccess();
                    })
                    .catch(async () => {});
                }
              );
            }
          }
        },
        storeSort: sortData => {
          if (sortData.sorters.length == 1) {
            const sorter = sortData.sorters[0];
            const ascending = sorter.ascending;
            const field = sorter.field;
            self.filter.orderBy = field;
            self.filter.orderByDescending = !ascending;
            self.changePage(0);
          }
        }
      },
      searchingClients: false,
      searchingMedications: false,
      formPrnMedications: [],
      activeClients: [],
      subscribed: false,
      firstLoading: true,
      showAddEditMedication: false,
      editMedicationId: null,
      filtersContainerHeight: 0,
      showReportRequestsModal: false
    };
  },
  mounted() {
    this.filter.dateFrom = formatDateOnlyMysql(
      this.getCurrentAdjustedDateTime()
    );
  },
  methods: {
    ...mapActions("layout", ["showAlertSuccess"]),
    async fetchInitialData() {
      this.calculateFilterWidth();
      this.searchMars(false);
      this.fetchClientOptions("");
      this.getActiveClients();
    },
    searchMars(delayed = true) {
      if (delayed) {
        if (this.lastMarsTimeout) {
          clearTimeout(this.lastMarsTimeout);
          this.lastMarsTimeout = null;
        }
        this.lastMarsTimeout = setTimeout(async () => {
          this.fetchMars();
        }, 1000);
      } else this.fetchMars();

      this.showResults = true;
    },
    changePage(page) {
      this.filter.page = page;
      this.fetchMars();
      this.scrollGridToTop();
    },
    scrollGridToTop() {
      const grid = document.querySelector(".mars-container .b-grid");
      grid.scrollTop = 0;
    },
    changeAssignedToMEToggle() {
      this.assignedToMe = !this.assignedToMe;
    },
    async fetchMars() {
      const result = await marsServer.query({
        episodeOfCareIds: this.filter.eoc.map(eoc => eoc.value),
        fromDate: this.filter.dateFrom
          ? formatDateTimeSql(
              this.filter.dateFrom +
                " " +
                (this.filter.timeFrom ? this.filter.timeFrom.value : "00:00:00")
            )
          : null,
        toDate: this.filter.dateTo
          ? formatDateTimeSql(
              this.filter.dateTo +
                " " +
                (this.filter.timeTo ? this.filter.timeTo.value : " 23:59:59")
            )
          : null,
        medicationIds: this.filter.medication.map(m => m.value),
        status: this.filter.marsStatus.map(status => status.value),
        page: this.filter.page,
        pageSize: this.filter.pageSize,
        orderBy: this.filter.orderBy,
        orderByDescending: this.filter.orderByDescending,
        assignedToMe: this.assignedToMe
      });
      this.list = result.records;
      this.listTotal = result.count;
    },
    async fetchClientOptions(search) {
      if (this.lastClientTimeout) {
        clearTimeout(this.lastClientTimeout);
        this.lastClientTimeout = null;
      }
      this.lastClientTimeout = setTimeout(async () => {
        if (!search || search.length == 0 || search.length >= 3) {
          this.searchingClients = true;
          const optionsResult = await eocServer.queryList(
            {
              searchPhrase: search,
              eocStatus:
                !search || search.length == 0 ? ["Active", "Pending"] : [],
              page: 1,
              pageSize: 50
            },
            { "Hide-Loading": true }
          );
          this.clientOptions = optionsResult.episodesOfCare.map(eoc => ({
            value: eoc.id,
            label: this.formatEocObj(eoc),
            data: eoc
          }));
          this.searchingClients = false;
        }
      }, 1000);
    },
    async searchMedications(search) {
      if (this.lastMedicationTimeout) {
        clearTimeout(this.lastMedicationTimeout);
        this.lastMedicationTimeout = null;
      }
      this.lastMedicationTimeout = setTimeout(async () => {
        if (!search || search.length == 0 || search.length >= 3) {
          this.searchingMedications = true;
          const medications = await medicationServer.query(
            { searchPhrase: search, page: 0, pageSize: 10, orderBy: "name" },
            { "Hide-Loading": true }
          );
          this.medications = medications.map(m => ({
            value: m.id,
            label: m.name
          }));
          this.searchingMedications = false;
        }
      }, 1000);
    },
    formatTimeOnly(time) {
      return formatTimeOnly(time, "HH:mm");
    },
    removeEocFilter(index) {
      const newValue = [...this.filter.eoc];
      newValue.splice(index, 1);
      this.filter.eoc = newValue;
    },
    removeDateFilter() {
      this.filter.dateFrom = null;
      this.filter.dateTo = null;
    },
    removeStatusFilter(index) {
      const newValue = [...this.filter.marsStatus];
      newValue.splice(index, 1);
      this.filter.marsStatus = newValue;
    },
    removeMedicationFilter(index) {
      const newValue = [...this.filter.medication];
      newValue.splice(index, 1);
      this.filter.medication = newValue;
    },
    calculateFilterWidth() {
      this.filterWidth = "250px";
    },
    clearAllFilters() {
      this.filter.eoc = [];
      this.filter.medication = [];
      this.filter.marsStatus = [];
      this.filter.dateFrom = null;
      this.filter.dateTo = null;
    },
    validateSubmitPrnMedication() {
      let withoutErrors = true;

      this.formPrnErrors.eoc = [];
      if (!this.formPrnId && !validateRequired(this.formPrn.eoc)) {
        this.formPrnErrors.eoc.push("This field is required");
        withoutErrors = false;
      }

      this.formPrnErrors.prnMedication = [];
      if (!this.formPrnId && !validateRequired(this.formPrn.prnMedication)) {
        this.formPrnErrors.prnMedication.push("This field is required");
        withoutErrors = false;
      }

      this.formPrnErrors.status = [];
      if (!validateRequired(this.formPrn.status)) {
        this.formPrnErrors.status.push("This field is required");
        withoutErrors = false;
      }

      this.formPrnErrors.date = [];
      if (!validateRequired(this.formPrn.date)) {
        this.formPrnErrors.date.push("This field is required");
        withoutErrors = false;
      }

      this.formPrnErrors.time = [];
      if (!validateRequired(this.formPrn.time)) {
        this.formPrnErrors.time.push("This field is required");
        withoutErrors = false;
      }

      return withoutErrors;
    },
    async submitPrnMedication(modalEvent) {
      modalEvent.preventDefault();
      const result = this.validateSubmitPrnMedication();
      if (result) {
        if (this.formPrnId) {
          await marsServer.update(this.formPrnId, {
            dateTime: formatDateTimeSql(
              this.formPrn.date + " " + this.formPrn.time.value
            ),
            status: this.formPrn.status.value,
            notes: this.formPrn.notes,
            givenBy: this.formPrn.givenBy ? this.formPrn.givenBy.value : null
          });
        } else {
          await marsServer.create({
            dateTime: formatDateTimeSql(
              this.formPrn.date + " " + this.formPrn.time.value
            ),
            prnMedicationId: this.formPrn.prnMedication.value,
            status: this.formPrn.status.value,
            notes: this.formPrn.notes,
            givenBy: this.formPrn.givenBy ? this.formPrn.givenBy.value : null
          });
        }

        this.fetchMars();
        this.$refs["form-modal"].hide();
        this.showAlertSuccess();
      }
    },
    async getActiveClients() {
      const optionsResult = await eocServer.queryList(
        {
          searchPhrase: "",
          eocStatus: ["Active", "Pending"],
          locationId: [],
          page: 1,
          pageSize: 50
        },
        {
          "Hide-Loading": true
        }
      );
      this.activeClients = optionsResult.episodesOfCare.map(eoc => ({
        value: eoc.id,
        label: this.formatEocObj(eoc),
        data: eoc
      }));
    },
    async fetchFormPrnMedications() {
      if (this.formPrn.eoc) {
        const optionsResult = await prnMedicationServer.query(
          this.formPrn.eoc.value,
          {}
        );
        this.formPrnMedications = optionsResult.map(prnMedication => ({
          value: prnMedication.id,
          label: prnMedication.medication.name,
          data: prnMedication
        }));
      } else this.formPrnMedications = [];
    },
    onModifyAddEditMedication() {
      this.showAddEditMedication = false;
      this.fetchMars();
    },
    computeHeights() {
      setTimeout(() => {
        const filtersContainerHeight = this.$refs.filtersContainer.clientHeight;
        this.filtersContainerHeight = filtersContainerHeight;
      }, 0);
    }
  },
  computed: {
    ...mapGetters("layout", ["getCurrentAdjustedDateTime"]),
    ...mapState("layout", {
      selectedLocation: state => state.selectedLocation,
      selectedLocationObj: state => state.selectedLocationObj,
      currentUser: state => state.currentUser
    }),
    items() {
      return this.list.map(item => {
        let rowHeight = 50;
        const singleLineHeight = 25;
        const charsMedicationPerLine = 35;
        const charsInstructionsPerLine = 35;
        const charsNotesPerLine = 35;
        const maxFactor = Math.max(
          Math.ceil(item.medication.name.length / charsMedicationPerLine),
          Math.ceil((item.notes ? item.notes.length : 0) / charsNotesPerLine),
          Math.ceil(
            (item.instructions ? item.instructions.length : 0) /
              charsInstructionsPerLine
          )
        );
        if (maxFactor > 1) rowHeight += singleLineHeight * (maxFactor - 1);
        return {
          ...item,
          rowHeight: rowHeight,
          inputRows: maxFactor
        };
      });
    },
    columns() {
      const self = this;
      let columns = [
        {
          text: "Status",
          field: "status",
          width: 140,
          editor: false,
          type: "template",
          template: data => {
            let className = "warning";
            let statusText = "Pending";
            if (data.record.data.status == "Given") {
              className = "success";
              statusText = "Given";
            }
            if (data.record.data.status == "NotGiven") {
              className = "danger";
              statusText = "Not Given";
            }
            return `<h6><span class="badge-v2 px-4 py-2 badge-${className} badge-fixed-size">${statusText}</span></h6>`;
          },
          sortable() {
            return self.filter.orderByDescending ? -1 : 1;
          }
        },
        {
          text: "Type",
          field: "type",
          flex: 1,
          editor: false,
          type: "template",
          template: data =>
            data.record.data.type ? data.record.data.type.toUpperCase() : "",
          sortable() {
            return self.filter.orderByDescending ? -1 : 1;
          }
        },
        {
          text: "Patient",
          field: "patient",
          flex: 1,
          editor: false,
          type: "template",
          template: data => this.formatEocObj(data.record.data.episodeOfCare),
          sortable() {
            return self.filter.orderByDescending ? -1 : 1;
          }
        },
        {
          text: "Date & Time",
          field: "datetime",
          width: 160,
          editor: false,
          type: "template",
          template: data =>
            this.selectedLocationObj.marsMilitaryTimes
              ? formatDateOnly(data.record.data.dateTime) +
                " " +
                formatToMilitaryTime(data.record.data.dateTime)
              : formatDate(data.record.data.dateTime),
          sortable() {
            return self.filter.orderByDescending ? -1 : 1;
          }
        },
        {
          text: "Medication",
          field: "medication",
          width: 200,
          editor: false,
          type: "template",
          template: data =>
            `<div class="text-wrap">${data.record.data.medication.name}</div>`,
          sortable() {
            return self.filter.orderByDescending ? -1 : 1;
          }
        },
        {
          text: "Dosage",
          field: "dosage",
          flex: 1,
          editor: false,
          type: "template",
          template: data =>
            data.record.data.dosageAmount +
            " " +
            data.record.data.unitOfMeasurement.name,
          sortable() {
            return self.filter.orderByDescending ? -1 : 1;
          }
        },
        {
          text: "Route",
          field: "route",
          flex: 1,
          editor: false,
          type: "template",
          template: data => data.record.data.medicationRoute.name,
          sortable() {
            return self.filter.orderByDescending ? -1 : 1;
          }
        },
        {
          text: "Given By",
          field: "givenBy",
          flex: 1,
          editor: false,
          type: "template",
          template: data =>
            data.record.data.givenBy
              ? formatUser(data.record.data.givenBy)
              : "",
          sortable: false
        },
        {
          text: "Signed By",
          field: "signedBy",
          flex: 1,
          editor: false,
          type: "template",
          template: data =>
            data.record.data.signedBy
              ? formatUser(data.record.data.signedBy)
              : "",
          sortable: false
        },
        {
          text: "Instructions",
          field: "instructions",
          editor: false,
          type: "template",
          width: 200,
          template: data =>
            `<div class="text-wrap">${data.record.data.instructions}</div>`,
          sortable: false
        },
        {
          text: "Notes",
          field: "notes",
          editor: false,
          type: "template",
          width: 200,
          template: data =>
            `<div class="text-wrap">${
              data.record.data.notes ? data.record.data.notes : ""
            }</div>`,
          sortable: false
        },
        {
          text: "Tools",
          type: "action",
          cellCls: "pointer-cell",
          field: "action",
          align: "right",
          width: 80,
          actions: [
            {
              tooltip: "More",
              renderer: ({ record }) => {
                const actions = [];

                actions.push({
                  content: "Edit",
                  callback: () => {
                    this.showAddEditMedication = true;
                    this.editMedicationId = record.id;
                  }
                });

                if (record.data.type == "Prn") {
                  actions.push({
                    content: "Delete",
                    callback: () => {
                      this.$dialog
                        .confirm(
                          {
                            title:
                              "Are you sure you want to delete this record?"
                          },
                          {
                            view: "confirm-delete"
                          }
                        )
                        .then(async () => {
                          await marsServer.delete(record.id);
                          await this.fetchMars();
                          this.showAlertSuccess();
                        })
                        .catch(function() {});
                    }
                  });
                }

                return this.createDropdownButton({
                  items: actions
                });
              }
            }
          ]
        }
      ];
      return columns;
    },
    hasFilters() {
      return (
        this.filter.eoc.length > 0 ||
        this.filter.medication.length > 0 ||
        this.filter.marsStatus.length > 0 ||
        this.filter.dateFrom ||
        this.filter.dateTo
      );
    },
    assignedToMe: {
      get() {
        return this.assignedToMeValue;
      },
      set() {
        this.$emit("change-assignedToMe");
      }
    },
    pageSize: {
      get() {
        return this.filter.pageSize.toString();
      },
      set(newValue) {
        this.filter.pageSize = parseInt(newValue);
        this.changePage(0);
      }
    },
    timeOptions() {
      if (this.selectedLocationObj.marsMilitaryTimes) {
        return timeOptions.map(time => ({
          value: time,
          label: time
        }));
      } else {
        return timeOptions.map(time => ({
          value: time,
          label: formatTimeOnly(time, "HH:mm")
        }));
      }
    },
    exportFilter() {
      return {
        patientIds: this.filter.eoc.map(eoc => eoc.data.id),
        statusValues: this.filter.marsStatus.map(s => {
          if (s.value == "Pending") return 0;
          if (s.value == "Given") return 1;
          return 2;
        }),
        dateFrom: this.filter.dateFrom
          ? this.filter.dateFrom +
            " " +
            (this.filter.timeFrom ? this.filter.timeFrom.value : "00:00:00")
          : null,
        dateTo: this.filter.dateTo
          ? this.filter.dateTo +
            " " +
            (this.filter.timeTo ? this.filter.timeTo.value : "23:59:59")
          : null,
        medicationIds: this.filter.medication.map(m => m.value),
        orderBy:
          this.filter.orderBy[0]?.toUpperCase() +
          this.filter.orderBy?.substring(1),
        sort: this.filter.orderByDescending ? "DESC" : "ASC",
        locationIds: [this.selectedLocation],
        assignedToMe: this.assignedToMe
      };
    }
  },
  watch: {
    showing: {
      handler: function(newValue) {
        if (newValue) {
          if (this.firstLoading) {
            const timeFrom = parseNearestTime(
              formatTimeOnlyMysql(
                moment(this.getCurrentAdjustedDateTime())
                  .subtract(1, "hour")
                  .toDate()
              )
            );
            this.filter.timeFrom = this.selectedLocationObj.marsMilitaryTimes
              ? {
                  value: timeFrom,
                  label: timeFrom
                }
              : {
                  value: timeFrom,
                  label: formatTimeOnly(timeFrom, "HH:mm")
                };
            setTimeout(() => {
              this.firstLoading = false;
            });
          }
          this.fetchInitialData();
          this.computeHeights();
        }
      }
    },
    "filter.eoc": function() {
      this.filter.page = 0;
      this.searchMars();
      this.computeHeights();
    },
    "filter.medication": function() {
      this.filter.page = 0;
      this.searchMars();
      this.computeHeights();
    },
    "filter.marsStatus": function() {
      this.filter.page = 0;
      this.searchMars();
      this.computeHeights();
    },
    "filter.dateFrom": function() {
      this.filter.page = 0;
      this.searchMars();
      this.computeHeights();
    },
    "filter.timeFrom": function() {
      if (!this.firstLoading) {
        this.filter.page = 0;
        this.searchMars();
        this.computeHeights();
      }
    },
    "filter.dateTo": function() {
      this.filter.page = 0;
      this.searchMars();
      this.computeHeights();
    },
    "filter.timeTo": function() {
      this.filter.page = 0;
      this.searchMars();
      this.computeHeights();
    },
    "formPrn.eoc": function() {
      this.fetchFormPrnMedications();
    },
    selectedFilter: function() {
      this.$refs.filterDropdown.updatePopper();
    },
    assignedToMe: function() {
      this.fetchMars();
    }
  }
};
</script>

<style scoped>
.mars-list {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.container-main {
  height: 45px;
}
.container-main:hover {
  cursor: pointer;
}
.b-dropdown-form:focus {
  outline: none !important;
}
.filter-values {
  width: 250px;
}
.filter-value {
  min-width: 100px;
  height: 29px;
  color: #a6a6a6;
  font-size: 14px;
  padding-left: 10px;
}
.filter-value-delete {
  position: absolute;
  top: -8px;
  right: -8px;
}
.filter-value-delete:hover {
  cursor: pointer;
}
.clear-all-filters:hover {
  cursor: pointer;
}
.filter-values {
  max-height: 200px;
  overflow-y: auto;
  overflow-x: hidden;
}
.filter-title {
  font-size: 16px;
}
.prn-medication-data {
  font-size: 14px;
  max-height: 168px;
  overflow-y: auto;
  overflow-x: hidden;
}
.filters-container >>> .container-filter-main-menu {
  min-width: 250px;
  left: -17px;
}
.vertical-separator {
  width: 1px;
  border-left: 1px solid;
  height: 100%;
}
.color-filter {
  color: #909db8;
}
.mars-list >>> .edit-notes-item {
  font-size: 14px;
}
.mars-list >>> .edit-status-item:hover {
  cursor: pointer;
}
.mars-list >>> .edit-status-item {
  width: 125px;
}
.mars-list >>> .b-grid-container .b-container {
  max-height: calc(
    100vh - var(--document-list-filters-container-height) - 240px
  );
  min-height: calc(
    100vh - var(--document-list-filters-container-height) - 240px
  ) !important;
}
</style>
<style>
.container-main-menu {
  max-height: 500px;
  overflow-y: auto;
}
.b-calendar-grid-help {
  display: none;
}
.b-calendar .b-calendar-grid {
  border: none;
}
.b-calendar .b-calendar-inner {
  min-width: 200px !important;
}
</style>
